export default __webpack_public_path__ + "static/media/list-group-usage.2d90a0cb.svg";